// src/api/axiosInstance.js

import axios from "axios";

const axiosInstance = axios.create({
    baseURL: "https://ofellio.com/api/",
  // baseURL: 'http://localhost:8080/',
  headers: {
    "Content-Type": "application/json",
  },
  // You can add timeout, interceptors, etc. if needed
});

export default axiosInstance;
